import { generateSequentialArray } from "../../common/utils";
import { Row } from "./PaymentLoaderStyles";

function PaymentLoader(props: any) {
  const { numItems } = props;
  const auxiliaryArray = generateSequentialArray(numItems ? numItems : 8);
  return (
    <>
      {auxiliaryArray.map((_, index) => (
        <Row key={index} />
      ))}
    </>
  );
}

export default PaymentLoader;
